































































































































































































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { DatePickerOptions } from "element-ui/types/date-picker";

import { mapGetters } from "vuex";
import ChooseSubjectVue from "../ChooseSubject.vue";
@Component({
    ...mapGetters(["accountBook"]),
    components: {
        "choose-subject": ChooseSubjectVue,
    }
})
export default class AssitInitData extends Vue {
    @Prop({ type: String })
    period?: string;

    @Prop({ type: Object })
    rowSubject?: Subject.Subject;

    //表格数据
    tableList: AssistSub.AssistSub[] = [];

    //科目索引
    subIndex: number = 0;
    isJan: boolean = false

    newTypes: any = {};

    newEndbalance: string = "";
    newEndbalanceOrg: string = "";
    newEndnumber: string = "";

    newJfbalance: string = "";
    newJfbalanceOrg: string = "";
    newJfnumber: string = "";

    newDfbalance: string = "";
    newDfbalanceOrg: string = "";
    newDfnumber: string = "";

    newInitbalance: string = "";
    newInitbalanceOrg: string = "";
    newInitnumber: string = "";

    assistList: Assist.AssistAccount[] = [];
    created() {
        if (this.rowSubject) this.subjectVal = this.rowSubject
        if (this.period) {
            this.period.indexOf("01月") == -1 ? this.isJan = false : this.isJan = true;
        }
    }
    get isClose() {
        return this.$store.state.accountBook.closePeriod != null
    }
    mounted() {
        this.fetchData()
    }
    includeUnit: boolean = false;

    @Watch("subjectVal")
    subjectValChange(val: Subject.Subject) {
        this.changeSubject(val);
    }

    get hasForeign() {
        if (this.subjectVal) {
            return this.subjectVal.currSymbol != null
        }
    }
    // 获取行数
    getSpan() {
        if (this.hasForeign) {
            if (this.includeUnit) return 3;
            else return 2;
        } else {
            if (this.includeUnit) return 2;
            else return 1;
        }
    }

    hasUnit(row: AssistSub.AssistSub) {
        // return row.measuringUnit != null
        for (let i = 0; i < this.tableList.length; i++) {
            const data = this.tableList[i];
            if (data.measuringUnit !== null) return true;
        }
        return false;
    }

    selectInner(e: any) {
        e.target.select()
    }
    // 改变科目数据
    subjectVal: Subject.Subject | null = null; //选中的科目
    changeSubject(val: Subject.Subject) {
        this.subjectVal = val;
        // this.rowSubject = this.subjectVal
        this.subjectVal.dimAccountTypes.forEach((v: any) => {
            this.newTypes[v] = "";
        })
        this.fetchData();
    }
    fetchData() {
        if (this.subjectVal) {
            Vue.axios
                .post(`dim/balance/` + this.subjectVal.id + `/find`, { headers: { "Content-Type": "application/x-www-form-urlencoded" } })
                .then(res => {
                    let flag = false;
                    res.data.forEach((v: any) => {
                        v.showEnd = false;
                        v.showDf = false;
                        v.showJf = false;
                        v.showInit = false;
                        v.showDfOrg = false;
                        v.showJfOrg = false;
                        v.showEndOrg = false;
                        v.showInitOrg = false;
                        v.showDfNumber = false;
                        v.showJfNumber = false;
                        v.showEndNumber = false;
                        v.showInitNumber = false;
                        if (v.relation.dimInventory) {
                            if (v.relation.dimInventory.measureUnit === "") {
                                v.relation.dimInventory.measureUnit = null
                            }
                        }
                        if (this.subjectVal) {
                            if (this.subjectVal.dimAccountTypes.indexOf("存货") != -1) v.measuringUnit = v.relation.dimInventory.measureUnit === null ? this.subjectVal.measuringUnit : v.relation.dimInventory.measureUnit;
                        }
                        if (v.measuringUnit != null) flag = true;
                    })
                    if (this.subjectVal) {
                        if (this.subjectVal.measuringUnit != null) flag = true;
                    }
                    this.includeUnit = flag;
                    this.tableList = res.data;
                });
        }
    }
    // 获取辅助核算列表
    getAssList(assist: string) {
        Vue.axios
            .post(`dim/find?accountBookId=${
                this.$store.state.accountBook.id
                }&dimAccountType=${assist}`)
            .then(res => {
                (<any>this.assistList)[assist] = res.data;
                this.$forceUpdate()
            });
    }

    canSave() {
        return JSON.stringify(this.newTypes) != "{}" && (this.newEndbalance != "" || this.newJfbalance != "" || this.newDfbalance != "" || this.newInitbalance != "")
    }

    getAssItem(assist: string, relation: any) {
        let item = relation[this.transRelation(assist).replace("Id", "")];
        if (item != null) return item.no + " " + item.name;
        else return ""
    }

    transRelation(val: string) {
        switch (val) {
            case "项目": return "dimItemId";
            case "客户": return "dimCustomerId";
            case "部门": return "dimDepartmentId";
            case "员工": return "dimEmployeeId";
            case "存货": return "dimInventoryId";
            case "供应商": return "dimProviderId";
            case "dimItemId": return "项目";
            case "dimCustomerId": return "客户";
            case "dimDepartmentId": return "部门";
            case "dimEmployeeId": return "员工";
            case "dimInventoryId": return "存货";
            case "dimProviderId": return "供应商";
            default: return "dimItemId";
        }
    }
    getRelation() {
        let obj: any = {};
        let newTypes = this.newTypes;
        Object.keys(newTypes).forEach(attr => {
            obj[this.transRelation(attr)] = newTypes[attr].id;

        });
        return obj;
    }

    toggleInput(row: any, attr: string, e?: any) {
        let parent: any = null;
        if (e) parent = e.currentTarget.parentNode;
        row[attr] = !row[attr];
        this.$forceUpdate();
        this.$nextTick(() => {
            if (e) {
                parent.querySelector("input").focus();
            }
        })
    }
    // 清除数据
    clearNew() {
        this.newEndbalance = "";
        this.newEndbalanceOrg = "";
        this.newEndnumber = "";

        this.newJfbalance = "";
        this.newJfbalanceOrg = "";
        this.newJfnumber = "";

        this.newDfbalance = "";
        this.newDfbalanceOrg = "";
        this.newDfnumber = "";

        this.newInitbalance = "";
        this.newInitbalanceOrg = "";
        this.newInitnumber = "";
        let newTypes = this.newTypes;
        Object.keys(newTypes).forEach(attr => {
            this.newTypes[attr] = ""

        });
    }

    // 保存新一行
    saveNew() {
        if (this.canSave()) {
            if (this.period && this.subjectVal) {
                let row = {
                    dimBalance: {
                        accountBookId: this.$store.state.accountBook.id,
                        dfbalance: this.newDfbalance,
                        dfbalanceOrg: this.newDfbalanceOrg,
                        dfnumber: this.newDfnumber,
                        endbalance: this.newEndbalance,
                        endbalanceOrg: this.newEndbalanceOrg,
                        endnumber: this.newEndnumber,
                        initbalance: this.newInitbalance,
                        initbalanceOrg: this.newInitbalanceOrg,
                        initnumber: this.newInitnumber,
                        jfbalance: this.newJfbalance,
                        jfbalanceOrg: this.newJfbalanceOrg,
                        jfnumber: this.newJfnumber,
                        period: this.period.substr(0, 4) + this.period.substr(5, 2),
                        subjectId: this.subjectVal.id,
                        subjectNo: this.subjectVal.no
                    },
                    relation: this.getRelation(),
                    measuringUnit: this.subjectVal.measuringUnit
                }
                Vue.axios
                    .post(`dim/balance/` + this.subjectVal.id + "/edit", row)
                    .then(res => {
                        this.fetchData()
                        this.$message.success("新增成功！")
                        this.$emit("success")
                        this.clearNew();
                    });
            }
        }
    }

    // 修改数值
    changeRow(row: AssistSub.AssistSub, e: any) {
        if (this.subjectVal) {
            Vue.axios
                .post(`dim/balance/` + this.subjectVal.id + "/edit", row)
                .then(res => {
                    this.fetchData()
                    this.$emit("success")
                    this.$message.success("修改成功！")
                });
        }
    }

    changeNewAss() {
        this.$forceUpdate();
        this.saveNew();
    }
}
